import createModule from "../createModule"
import { Creators as notificationsCreators } from "modules/notifications/model"
import view from "./view"
import { Creators } from "./model"
import {
  getModelId,
  getFiles,
  getUploadConfig,
  getScanResult,
  getUploadOption,
  getUploadDateTime,
  getUploadedFiles,
  getOverlappingDates,
  getExperimentId,
  getResourceInfo,
  getExperiment } from "./selectors"
import { getSteps } from "./selectors/steps"
import { getActiveStepFromParams } from "helpers/upload-steps"
import withUrlParams from "hocs/withUrlParams"
import withNavigate from "hocs/withNavigate"
import { MODELS_QUERY, getModels } from "resources/models"

export default withUrlParams(withNavigate(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    experimentId: getExperimentId(state, props),
    experiment: getExperiment(state),
  }),
  required: ["account", "experimentId"],
  data: [{
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    resource: "experimentMeta",
    as: null,
    url: ({ account, experimentId }) => `/api/${account}/e/${experimentId}`,
  }, {
    resource: "experimentResourceInfo",
    url: ({ experiment }) => {
      if (!experiment) { return null }

      return {
        id: `experimentResourceInfo-${experiment.resourceId}`,
        query: `query ($resourceId: String!) {
        ${experiment.resourceType === "RESEARCH_TOPIC" ? "researchTopic" : "portfolio"} (id: $resourceId) {
          id,
          name
        }
      }`,
        variables: { resourceId: experiment.resourceId },
      }
    },
  }, {
    ...MODELS_QUERY,
    as: null,
  }],
  mapStateToProps: (state, props) => ({
    activeStep: getActiveStepFromParams(props.params),
    steps: getSteps(state, props),
    files: getFiles(state),
    uploadedFiles: getUploadedFiles(state),
    scanResult: getScanResult(state),
    uploadOption: getUploadOption(state),
    uploadDateTime: getUploadDateTime(state),
    uploadConfig: getUploadConfig(),
    overlappingDates: getOverlappingDates(state),
    resourceInfo: getResourceInfo(state),
    models: getModels(state),
    modelId: getModelId(state, props),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
  },
})))
